"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsWeekend = exports.useMonthNames = exports.useAddDays = exports.useSubstractDays = exports.useAddMonths = exports.useSubstractMonths = exports.useFullHour = exports.useDayEnd = exports.useDayStart = exports.useMonthStart = exports.useMonthEnd = exports.useParseDate = exports.useFormatDate = exports.useLocalizedDateFormat = exports.useDateFnsLocale = void 0;
var de_1 = __importDefault(require("date-fns/locale/de"));
var en_US_1 = __importDefault(require("date-fns/locale/en-US"));
var date_fns_1 = require("date-fns");
var useDateFnsLocale = function () {
    var _a;
    return ((_a = navigator.language) === null || _a === void 0 ? void 0 : _a.startsWith("de")) ? de_1.default : en_US_1.default;
};
exports.useDateFnsLocale = useDateFnsLocale;
var useLocalizedDateFormat = function () {
    return navigator.language.startsWith("de") ? "dd.MM.yyyy" : "MM/dd/yyyy";
};
exports.useLocalizedDateFormat = useLocalizedDateFormat;
var useFormatDate = function () {
    var dateFns = (0, exports.useDateFnsLocale)();
    return function (date, _format) { return (0, date_fns_1.format)(date, _format, { locale: dateFns }); };
};
exports.useFormatDate = useFormatDate;
var useParseDate = function () { return date_fns_1.parseISO; };
exports.useParseDate = useParseDate;
var useMonthEnd = function () {
    var getDayEnd = (0, exports.useDayEnd)();
    return function (date) {
        if (typeof date !== typeof {})
            return date;
        var day = (0, date_fns_1.lastDayOfMonth)(date);
        return getDayEnd(day);
    };
};
exports.useMonthEnd = useMonthEnd;
var useMonthStart = function () {
    var getDayStart = (0, exports.useDayStart)();
    return function (date) {
        if (typeof date !== typeof {})
            return date;
        var monthStart = new Date(date.getTime());
        monthStart.setDate(1);
        return getDayStart(monthStart);
    };
};
exports.useMonthStart = useMonthStart;
var useDayStart = function () { return function (date) {
    if (typeof date !== typeof {})
        return date;
    var start = new Date(date.getTime());
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    return start;
}; };
exports.useDayStart = useDayStart;
var useDayEnd = function () { return function (date) {
    if (typeof date !== typeof {})
        return date;
    var end = new Date(date.getTime());
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    return end;
}; };
exports.useDayEnd = useDayEnd;
var useFullHour = function () { return function (date) {
    if (typeof date !== typeof {})
        return date;
    var minutes = date.getMinutes();
    var hours = date.getHours();
    return (0, date_fns_1.set)(date, {
        hours: (minutes >= 30 && hours < 23) ? hours + 1 : hours,
        minutes: 0,
        seconds: 0,
    });
}; };
exports.useFullHour = useFullHour;
var useSubstractMonths = function () { return function (date, num) {
    return (0, date_fns_1.sub)(date, { months: num });
}; };
exports.useSubstractMonths = useSubstractMonths;
var useAddMonths = function () { return function (date, num) {
    return (0, date_fns_1.addMonths)(date, num);
}; };
exports.useAddMonths = useAddMonths;
var useSubstractDays = function () { return function (date, num) {
    return (0, date_fns_1.sub)(date, { days: num });
}; };
exports.useSubstractDays = useSubstractDays;
var useAddDays = function () { return function (date, num) {
    return (0, date_fns_1.addDays)(date, num);
}; };
exports.useAddDays = useAddDays;
var useMonthNames = function () {
    var dateFns = (0, exports.useDateFnsLocale)();
    var months = [];
    for (var m = 0; m <= 11; m++) {
        months.push((0, date_fns_1.format)(new Date(2015, m, 10), "MMMM", { locale: dateFns }));
    }
    return months;
};
exports.useMonthNames = useMonthNames;
var useIsWeekend = function () { return date_fns_1.isWeekend; };
exports.useIsWeekend = useIsWeekend;
